import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toast from './components/Toast/index';
Vue.use(Toast);
// 引用API文件
import http from './api/http.js'
import "swiper/css/swiper.css"

import { Uploader } from 'vant'
import { Swipe, SwipeItem } from 'vant';
import { List } from 'vant';
import { Field } from 'vant';
import { Icon } from 'vant';
import { Loading } from 'vant';

Vue.use(Loading);
Vue.use(Icon);
Vue.use(Field);
Vue.use(Uploader)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
// 全局
Vue.prototype.$http = http;

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
